import React, {useState, useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom'
import {mostrarPagos} from "../../redux/reducers/pagosReducers";

import {
    useMediaQuery, TextField, Grid, TableCell, TableBody, TableRow, Button, Dialog, DialogContent, Checkbox, Typography, FormControlLabel, DialogActions, Theme,TableFooter
} from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import {formatPeso, formatDate} from '../../helpers';
import downloadFiles from '../../helpers/downloadFiles';
import ReciboPago from "../../components/recibo";
import {SelectRuta,SelectAgente,SelectCaja,SelectEnum} from "../../components/selects";
import {TableSort, ButtonResponsive, SeacrhAppBar, LoadingProgress, CustomListItem, ListViewMode, AppBar,
    MostrarError, FilteredAlert, Pagination} from "../../components";
import {AttachFile, CloudDownloadOutlined, FilterList} from "@mui/icons-material";
import Strings from '../../assets/strings'
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IPagoFilter} from "../../redux/types/IPago";
import moment from "moment";
import TopBarDialog from "../../components/topBar/TopBarDialog";

const useStyles = makeStyles((theme:Theme) => ({
  pagAnulado:{
    background: "#fff1f1",
    "& td, th":{
      color:theme.palette.error.light,
    }
  },
    row:{
        "&.pagTipo4":{
            background:"#d6f4ff !important"
        },
        "&.pagTipo8":{
            background:"#f8eaca !important"
        },
    },
    cliente:{
        "& svg":{
            fontSize: 14,
            marginLeft: -4,
            marginBottom: -1,
            color:theme.palette.secondary.main
        }
    }
}));
const initialState:IPagoFilter={
    name:'',
    fechaDesde: '',
    fechaHasta: '',
    creadoPor: undefined,
    usuarioIdAgente:undefined,
    cajaId:undefined,
    rutaId:undefined,
    tipo:undefined,
    incluirAnulados:false,
    tipoFormaPago:undefined,
    //pagination
    page: 1,
    pageSize:15,
    orderBy:"",
    orderByIsDescending:undefined
}
export default function PagosRealizados() {
    const classes = useStyles();

    const pagos = useAppSelector(state => state.pagos);
    const viewTableList = useAppSelector(state => state.theme.viewTableList);
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const dispatch = useAppDispatch();

    const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));

    const [openFilter, setOpenFilter] = useState(false)
    const [filter, setFilter] = useState(initialState);

    const {list, status,error,filtered} = pagos;

    const isEmpty = (list?.items?.length === 0);

    useEffect(() => {
        dispatch(mostrarPagos({}));
    }, [dispatch]);
    //set filtered params
    useEffect(()=>setFilter({...initialState,...filtered}),[setFilter,filtered])


    const handleFilter = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name, value,checked} = e.target;
        if(name === "name" || name === "page" || name === "pageSize")
            return dispatch(mostrarPagos({...filter,[name]:value}));

        if(name === "incluirAnulados")
            setFilter({...filter,[name]:checked});
        else
            setFilter({...filter,[name]:value});
    };
    const resetFilter = () => {
        setOpenFilter(false);
        dispatch(mostrarPagos({}));
    };
    const searchFilter = () => {
        setOpenFilter(false);
        dispatch(mostrarPagos(filter));
    };
    const tableSortProps = (orderBy:string) => {
        return {
            active:filter.orderBy === orderBy,
            direction: filter.orderByIsDescending ? "desc" : 'asc',
            onClick:()=> mostrarPagos({...filter, orderBy, orderByIsDescending: !filter.orderByIsDescending})
        }
    }

    return (
      <>
          <AppBar />
          <Dialog open={openFilter} onClose={()=>setOpenFilter(false)} maxWidth={"xs"}>
              <TopBarDialog title={Strings.filtrar} onClose={()=>setOpenFilter(false)} light/>

              <DialogContent>
                  <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                          <TextField
                              label={Strings.fechaDesde}
                              type="date"
                              name="fechaDesde"
                              value={filter.fechaDesde}
                              onChange={handleFilter}
                              fullWidth
                              InputLabelProps={{
                                  shrink: true,
                              }}
                          />
                      </Grid>
                      <Grid item xs={12} md={6} >
                          <TextField
                              label={Strings.fechaHasta}
                              type="date"
                              name="fechaHasta"
                              value={filter.fechaHasta}
                              onChange={handleFilter}
                              fullWidth
                              InputLabelProps={{
                                  shrink: true,
                              }}
                          />
                      </Grid>
                      <Grid item xs={12} md={6} >
                          <SelectAgente
                              label={Strings.creadoPor}
                              value={filter.creadoPor}
                              onChange={handleFilter}
                              name="creadoPor"
                          />
                      </Grid>
                      <Grid item xs={12} md={6}>
                          <SelectAgente
                              all
                              label={Strings.agenteAcomisionar}
                              value={filter.usuarioIdAgente}
                              onChange={handleFilter}
                              name="usuarioIdAgente"
                          />
                      </Grid>
                      <Grid item xs={12}>
                          <SelectCaja
                              name= 'cajaId'
                              allowAll
                              value={filter.cajaId}
                              onChange={handleFilter}
                          />
                      </Grid>
                      <Grid item xs={6}>
                          <SelectEnum all value={filter.tipo} name={"tipo"} label={Strings.pago}
                                      onChange={handleFilter} group={"tiposPago"} />
                      </Grid>
                      <Grid item xs={6}>
                          <SelectEnum value={filter.tipoFormaPago} name={"tipoFormaPago"} label={Strings.tipoFormaPago}
                                      onChange={handleFilter} group={"tiposFormasPago"} />
                      </Grid>
                      <Grid item xs={12}>
                          <SelectRuta value={filter.rutaId} name={"rutaId"} onChange={handleFilter} />
                      </Grid>
                      <FormControlLabel
                          control={<Checkbox checked={filter.incluirAnulados} onChange={handleFilter} name="incluirAnulados" />}
                          label={Strings.ver+" "+Strings.anulado}
                          labelPlacement="start"
                      />
                  </Grid>
                  <br/>
              </DialogContent>
              <DialogActions>
                  <Button onClick={resetFilter} color={"warning"} size={"small"} sx={{textTransform:"capitalize"}}>
                      {Strings.restablecer}
                  </Button>
                  <Button color="primary" onClick={searchFilter} variant={"outlined"}>{Strings.filtrar}</Button>
              </DialogActions>
          </Dialog>


          <section className="contentInner" style={status==="loading"?{opacity:.8}:{opacity:1}}>
              {status==="loading" && <LoadingProgress vh/>}
              {error && <MostrarError errors={error}/>}

              <ListViewMode pageRows={list?.pageSize} pageTotalRows={list?.totalCount}>

                  <SeacrhAppBar name="name" value={filter.name} onChange={handleFilter}/>
                  <ButtonResponsive icon={<FilterList/>} text={Strings.filtrar} onClick={() => setOpenFilter(!openFilter)}/>
                  <ButtonResponsive icon={<CloudDownloadOutlined/>} text={Strings.exportar} disabled={isEmpty} onClick={()=>downloadFiles(filter,"pagos")}/>

                  <FilteredAlert onClose={resetFilter} filter={filtered}/>
              </ListViewMode>

              {(!viewTableList && smVewport)?(
                  list?.items?.map(pag =>
                      <CustomListItem key={pag.id}
                                      onClick={()=> navigate(pathname,{state:{recibo:pag}})}
                                      lt={pag.cliente}
                                      // lb={<Typography variant={"caption"}><SelectEnum value={pag.tipo?.toString()} group={"tiposPago"} /></Typography>}
                                      rt={<Typography color={"primary"}>{formatPeso(pag.totalPago)}</Typography>}
                                      rb={<Typography variant="caption">{formatDate(pag.fecha)}</Typography>}
                      />
                  )
              ):(
                  <TableSort data={[
                      {pro:"cliente",text:Strings.prestatario},
                      {pro:"pagFecha",text:Strings.fecha},
                      {pro:"fechaVencimiento",text:Strings.fechaVencimiento},
                      {pro:"caja",text:Strings.caja},
                      {pro:"usuarioCreadoPor",text:Strings.creadoPor},
                      {pro:"pagConcepto",text:Strings.concepto},
                      {pro:"pagCapital",text:Strings.capital, align: "right"},
                      {pro:"pagInteres",text:Strings.interes, align: "right"},
                      {pro:"pagMora",text:Strings.mora, align: "right"},
                      {pro:"pagDescuento",text:Strings.descuento, align: "right"},
                      {pro:"pagComision",text:Strings.comision, align: "right"},
                      {pro:"pagSeguro",text:Strings.seguro, align: "right"},
                      {pro:"otros",text:Strings.otros, align: "right"},
                      {pro:"totalPago",text:Strings.totalPagado, align: "right"},
                  ]} onSort={tableSortProps} lessVh={144}>
                      <TableBody>
                      {list?.items?.map(pag =>
                              <TableRow key={pag.id}
                                        className={classes.row + (pag.fechaAnulacion?" "+classes.pagAnulado:" pagTipo"+pag.tipo)}
                                        onClick={()=> navigate(pathname, {state: {recibo: pag}})}>
                                  <TableCell className={classes.cliente}>
                                      {!!pag.adjunto && <AttachFile />}
                                      {pag.cliente}
                                  </TableCell>
                                  <TableCell>{formatDate(pag.fecha)}</TableCell>
                                  <TableCell>{formatDate(pag.fechaVencimiento)}</TableCell>
                                  <TableCell>{pag.caja}</TableCell>
                                  <TableCell>{pag.usuarioCreadoPor}</TableCell>
                                  <TableCell>{pag.concepto}</TableCell>

                                  {(pag.tipo === 4 || pag.tipo === 8)?(
                                      <>
                                          <TableCell colSpan={7}/>
                                      </>
                                  ):(
                                      <>
                                          <TableCell align={"right"}>{formatPeso(pag.capital)}</TableCell>
                                          <TableCell align={"right"}>{formatPeso(pag.interes)}</TableCell>
                                          <TableCell align={"right"}>{formatPeso(pag.mora)}</TableCell>
                                          <TableCell align={"right"}>{formatPeso(pag.descuento)}</TableCell>
                                          <TableCell align={"right"}>{formatPeso(pag.comision)}</TableCell>
                                          <TableCell align={"right"}>{formatPeso(pag.seguro)}</TableCell>
                                          <TableCell align={"right"}>{formatPeso(pag.otros)}</TableCell>

                                      </>
                                  )}
                                  <TableCell align={"right"}>{formatPeso(pag.totalPago)}</TableCell>
                              </TableRow>
                      )}
                      </TableBody>
                      {!!list?.footer &&
                          <TableFooter>
                              <TableRow>
                                  <TableCell align={"right"} colSpan={6}>Total:</TableCell>
                                  <TableCell align={"right"}>{formatPeso(list.footer.capital)}</TableCell>
                                  <TableCell align={"right"}>{formatPeso(list.footer.interes)}</TableCell>
                                  <TableCell align={"right"}>{formatPeso(list.footer.mora)}</TableCell>
                                  <TableCell align={"right"}>{formatPeso(list.footer.descuento)}</TableCell>
                                  <TableCell align={"right"}>{formatPeso(list.footer.comision)}</TableCell>
                                  <TableCell align={"right"}>{formatPeso(list.footer.seguro)}</TableCell>
                                  <TableCell align={"right"}>{formatPeso(list.footer.otros)}</TableCell>
                                  <TableCell align={"right"}>{formatPeso(list.footer.totalPago)}</TableCell>
                              </TableRow>
                          </TableFooter>
                      }
                  </TableSort>

              )}
              {!!list &&
                  <Pagination
                      empty={Boolean(isEmpty && status !== "loading")}
                      count={list.totalCount || 0}
                      page={list.pageNumber - 1}
                      rowsPerPage={filter.pageSize??15}
                      onPageChange={(e, page) => {
                          dispatch(mostrarPagos({...filter,page:page + 1}));
                      }}
                      onRowsPerPageChange={handleFilter}
                  />
              }
          </section>
          <ReciboPago toPreIcon/>
      </>
    );
}
